export default {
  SET_CHAINS(state, chains) {
    state.chains = chains
  },
  SET_CHAINS_LOADING(state, value) {
    state.chainsLoading = value
  },
  SET_CHAINS_LOADED(state, value) {
    state.chainsLoaded = value
  },
  SET_ALL_CHAINS(state, chains) {
    state.allChains = chains
  },
  SET_ALL_CHAINS_LOADING(state, value) {
    state.allChainsLoading = value
  },
  SET_ALL_CHAINS_LOADED(state, value) {
    state.allChainsLoaded = value
  },
  SET_HEALTH_STATUS(state, value) {
    state.healthStatus = value
  },
  SET_HEALTH_ERROR(state, value) {
    state.healthError = value
  },
  SET_API_KEY(state, value) {
    state.apiKey = value || null
  },
}
